module.exports = __webpack_public_path__ + "static/media/v1m.76876022.mp4";